/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Address = {
  properties: {
    type: {
      type: 'string',
      isRequired: true,
    },
    formattedValue: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
